module.exports = __webpack_public_path__ + "img/Apple_Podcast_Icon.25b99b01.png";